// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../Users/xwxgs/Desktop/meishubao/llm/scratch-editor/node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../Users/xwxgs/Desktop/meishubao/llm/scratch-editor/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".direction-picker_button-row_GUAHP {\n    justify-content: center;\n    margin-bottom: 1rem;\n}\n", "",{"version":3,"sources":["webpack://./src/components/direction-picker/direction-picker.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".button-row {\n    justify-content: center;\n    margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button-row": "direction-picker_button-row_GUAHP",
	"buttonRow": "direction-picker_button-row_GUAHP"
};
module.exports = ___CSS_LOADER_EXPORT___;
